/******************************************** STYLING *********************************************/
const s = require('../auth-panel-root.scss');

/************************************** THIRD-PARTY IMPORTS ***************************************/
import React from 'react';
import DocumentTitle from 'react-document-title';
import cn from 'classnames';
import {inject} from 'mobx-react';

/**************************************** PROJECT IMPORTS *****************************************/
import {translate, SubmitButton} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
interface EmailVerificationBaseCntProps {
    sendVerificationEmail: EventHandler;
}

/********************************************* EXPORT *********************************************/
/**
 * UI for card to resend verification link when provided link was invalid
 */
export class EmailVerificationBaseCardView extends React.Component<EmailVerificationBaseCntProps> {
    render() {
        return (
            <DocumentTitle title={`${translate('title_email_verification')} - CANImmunize`}>
                <div className={cn(s[`input-card`], `h-100p`)}>
                    <div className={cn(s[`card-info-section-wrapper`])}>
                        <h2 className={cn(s[`input-card-text`], `mr-15 ml-15 mb-25`)}>
                            {translate(`tap_the_button_below_to_resend_the_email`)}
                        </h2>
                        <SubmitButton onClick={this.props.sendVerificationEmail}>
                            {translate(`email_verify_resend`)}
                        </SubmitButton>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}
